module.exports = {"systemInfo":{"title":"ข้อมูลระบบ","name":"ชื่อ","description":"รายละเอียด","updateLog":"รายการปรับปรุง","version":"เวอร์ชั่น","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/systemInfo.json
// module id = 750
// module chunks = 116